import { useEffect, useMemo, useState } from "react";
import React from "react";
import "./style.scss";
import PagesHeader from "@components/PagesHeader";
import SubscriptionHead from "./components/SubscriptionHead";
import Calculator from "./components/Calculator";
import SubscriptionCards from "./components/SubscriptionCards";
import SubscriptionList from "./components/SubscriptionList";
import SubscriptionFooter from "./components/SubscriptionFooter";
import RewardsSlider from "./components/RewardsSlider";
import {
  checkPrime,
  getSubscriptionList,
  SUBSCRIPTION_CACHE_TIME,
  SUBSCRIPTION_STALE_TIME,
} from "@api/subscriptions";
import { useQuery } from "@tanstack/react-query";
import AboArchive from "./components/AboArchive";

export default function SubscriptionPage() {
  const [hasSubscription, setHasSubscription] = useState(false);
  const [hasHistoryAbo, setHasHistoryAbo] = useState(false);
  const [hasPrime, setHasPrime] = useState(false);

  const { data: { subscriptions: subscriptionList = [] } = {} } = useQuery({
    queryKey: ["subscription-list"],
    queryFn: () => getSubscriptionList(),
    staleTime: SUBSCRIPTION_STALE_TIME,
    cacheTime: SUBSCRIPTION_CACHE_TIME,
  });

  const { data: { subscriptions: cancelledSubscriptionList = [] } = {} } =
    useQuery({
      queryKey: ["cancelled-subscription-list"],
      queryFn: () =>
        getSubscriptionList({
          statuses: ["Cancelled"],
        }),
      staleTime: SUBSCRIPTION_STALE_TIME,
      cacheTime: SUBSCRIPTION_CACHE_TIME,
    });

  const { data } = useQuery({
    queryKey: ["subscription-check-prime"],
    queryFn: () => checkPrime(),
    staleTime: SUBSCRIPTION_STALE_TIME,
    cacheTime: SUBSCRIPTION_CACHE_TIME,
  });

  const sortedSubscriptionList = useMemo(() => {
    return subscriptionList.filter(
      (subscription) =>
        subscription.subscriptionStatus === "Active" ||
        subscription.subscriptionStatus === "Paused",
    );
  }, [subscriptionList]);

  const aboData = useMemo(() => {
    return cancelledSubscriptionList.filter(
      (subscription) => subscription.subscriptionStatus === "Cancelled",
    );
  }, [cancelledSubscriptionList]);

  useEffect(() => {
    const hasActiveOrPaused = subscriptionList.some(
      (subscription) =>
        subscription.subscriptionStatus === "Active" ||
        subscription.subscriptionStatus === "Paused",
    );

    setHasSubscription(hasActiveOrPaused);
    setHasHistoryAbo(aboData.length > 0);
  }, [subscriptionList, aboData]);

  useEffect(() => {
    setHasPrime(data.isPrime);
  }, [data]);

  return (
    <section className="subscription-page">
      <PagesHeader>
        Mein Premium<strong>Abo</strong>
      </PagesHeader>

      <SubscriptionHead hasSubscription={hasSubscription} />

      {hasSubscription ? (
        <>
          <SubscriptionList subscriptionList={sortedSubscriptionList} />
          {hasHistoryAbo && <AboArchive aboData={aboData} />}
        </>
      ) : (
        <Calculator />
      )}

      {hasSubscription ? (
        <RewardsSlider hasPrime={hasPrime} />
      ) : (
        <SubscriptionCards />
      )}

      <SubscriptionFooter hasSubscription={hasSubscription} />

      {!hasSubscription && hasHistoryAbo && <AboArchive aboData={aboData} />}
    </section>
  );
}
